import { render, staticRenderFns } from "./MakeWithdraw.vue?vue&type=template&id=6d6cf70d"
import script from "./MakeWithdraw.vue?vue&type=script&lang=js"
export * from "./MakeWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports